<div class="base-dialog">
  <div mat-dialog-title flexLayout="row" class="titleContent">
    <ng-content select="[title]"></ng-content>
  </div>

  <div mat-dialog-close="true" class="closeContent">
    <ng-content select="[close]"></ng-content>
  </div>

  <mat-dialog-content
    fxLayout="column"
    fxLayoutAlign="center center"
    class="content"
  >
    <ng-content select="[content]"></ng-content>
  </mat-dialog-content>

  <mat-dialog-actions flexLayout="column" class="btnContent">
    <ng-content select="[actions]"></ng-content>
  </mat-dialog-actions>
</div>
